import React from "react";

function MetarTaf({
  metarsLink,
  tafsLink,
  adipFaaLink,
  terminalLink,
  notamsLink,
  windsLink,

}) {
  return (
    <div style={{ marginTop: "8px", textAlign: "left" }}>
      <div style={{ marginTop: "6px" }}>
      <a 
            href={metarsLink} 
            target="_blank" 
            rel="noopener noreferrer"
            >
                METAR
      </a>
      </div>

      <div style={{ marginTop: "6px" }}>
      <a 
            href={tafsLink} 
            target="_blank" 
            rel="noopener noreferrer"
            >
                TAF
      </a>
        </div>
      <div style={{ marginTop: "6px" }}>
          <a 
                href={adipFaaLink} 
                target="_blank" 
                rel="noopener noreferrer"
                >
                    Airport Data FAA
          </a>
        </div>

        <div style={{ marginTop: "6px" }}>
          <a 
                href={terminalLink} 
                target="_blank" 
                rel="noopener noreferrer"
                >
                    Terminal Procedures (Approaches)
          </a>
        </div>
        
        <div style={{ marginTop: "6px" }}>
          <a 
                href={notamsLink} 
                target="_blank" 
                rel="noopener noreferrer"
                >
                    NOTAMs
          </a>
        </div>
        <div style={{ marginTop: "6px" }}>
      <a 
            href={windsLink} 
            target="_blank" 
            rel="noopener noreferrer"
            >
                Winds Aloft
      </a>
      </div>
        

    </div>
  );
}

export default MetarTaf;